export const GET_QUIZ_RESULTS_REQUEST = 'GET_QUIZ_RESULTS_REQUEST'
export const GET_QUIZ_RESULTS_SUCCESS = 'GET_QUIZ_RESULTS_SUCCESS'
export const GET_QUIZ_RESULTS_FAILED = 'GET_QUIZ_RESULTS_FAILED'